// namespace (소문자)
export const NAMESPACE = 'board';
//getters
export const ARTICLE = 'ARTICLE';
export const ARTICLE_LIST = 'ARTICLE_LIST';
export const ARTICLE_COUNT = 'ARTICLE_COUNT';
export const ARTICLE_LIST2 = 'ARTICLE_LIST2';
export const ARTICLE_COUNT2 = 'ARTICLE_COUNT2';
export const ARTICLE_LIST3 = 'ARTICLE_LIST3';
export const ARTICLE_COUNT3 = 'ARTICLE_COUNT3';
//actions
export const CREATE_ARTICLE = 'CREATE_ARTICLE';
export const CREATE_KEYWORD_INQUIRY = 'CREATE_KEYWORD_INQUIRY';
export const FETCH_ARTICLE = 'FETCH_ARTICLE';
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE';
export const DELETE_ARTICLE = 'DELETE_ARTICLE';
export const FETCH_ARTICLE_LIST = 'FETCH_ARTICLE_LIST';
export const FETCH_KEYWORD_ARTICLE_LIST = 'FETCH_KEYWORD_ARTICLE_LIST';
export const EXCEL_DOWNLOAD_ARTICLE_LIST = 'EXCEL_DOWNLOAD_ARTICLE_LIST';
//mutations
export const SET_ARTICLE = 'SET_ARTICLE';
export const SET_ARTICLES = 'SET_ARTICLES';

//state
export const BOARD_ARTICLE_RESET_STATE = 'BOARD_ARTICLE_RESET_STATE';
export const BOARD_ARTICLES_RESET_STATE = 'BOARD_ARTICLES_RESET_STATE';
export const BOARD_ARTICLES2_RESET_STATE = 'BOARD_ARTICLES2_RESET_STATE';
export const BOARD_ARTICLES3_RESET_STATE = 'BOARD_ARTICLES3_RESET_STATE';
